import { store, persistor, rootReducer } from './store';
import * as sensorActions from './sensor/actions';
import * as sensorSelectors from './sensor/selectors';
import * as farmActions from './farm/actions';
import * as farmSelectors from './farm/selectors';
import * as controlActions from './control/actions';
import * as controlSelectors from './control/selectors';
import * as recommendationActions from './recommendation/actions';
import * as recommendationSelectors from './recommendation/selectors';
import * as scheduleActions from './schedule/actions';
import * as scheduleSelectors from './schedule/selectors';
import {
  loadUserSettings,
  patchUserSettings,
} from './settings/actions';
import * as settingsSelectors from './settings/selectors';
import * as webActions from './client/actions';
import * as webSelectors from './client/selectors';
import * as anomalyActions from './anomaly/actions';
import * as anomalySelectors from './anomaly/selectors';
import {
  loadAndPrepareMapDataByRanchIds,
  selectSensorsFeaturesByRanchId,
  selectBlocksFeaturesByRanchId,
  selectRanchFeaturesByRanchId,
  calculateGroupStateForPresentationModes,
  getCropStateByStress,
  selectRanchesFeatures,
} from './map-data';
import hooks from './hooks';
import {
  getPercentAvailable,
  getVolumeAvailable,
} from './helper/sensors';

const actions = {
  ...sensorActions,
  ...farmActions,
  ...controlActions,
  ...webActions,
  ...recommendationActions,
  ...scheduleActions,
  ...anomalyActions,
  loadAndPrepareMapDataByRanchIds,
  loadUserSettings,
  patchUserSettings,
};

const selectors = {
  ...sensorSelectors,
  ...farmSelectors,
  ...controlSelectors,
  ...webSelectors,
  ...settingsSelectors,
  ...recommendationSelectors,
  ...scheduleSelectors,
  ...anomalySelectors,
  selectSensorsFeaturesByRanchId,
  selectBlocksFeaturesByRanchId,
  selectRanchFeaturesByRanchId,
  selectRanchesFeatures,
};

const helpers = {
  getPercentAvailable,
  getVolumeAvailable,
};

export {
  store,
  persistor,
  rootReducer,
  actions,
  hooks,
  selectors,
  calculateGroupStateForPresentationModes,
  helpers,
  getCropStateByStress,
};
